module.exports = __webpack_public_path__ + "static/media/unwatched.d5678329.svg";